import { createTheme } from '@mui/material';

export const OrangeTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#FF5722', // Cor principal laranja
            contrastText: '#FFFFFF' // Texto branco para contraste
        },
        secondary: {
            main: '#FFC107', // Cor secundária dourada
            contrastText: '#FFFFFF'
        },
        background: {
            default: '#FFF3E0', // Cor de fundo suave
            paper: '#FFECB3' // Papel laranja claro
        },
        text: {
            primary: '#212121', // Texto primário escuro
            secondary: '#757575', // Texto secundário mais claro
            disabled: '#BDBDBD' // Texto desabilitado
        },
        divider: '#FF9800' // Cor do divisor (pode ser uma tonalidade de laranja)
    }
});
